module.exports = __webpack_public_path__ + "img/arrow-down-left.09b2b0bd.svg";